"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LABORATORY = void 0;
var LABORATORY = 'Laboratory';
exports.LABORATORY = LABORATORY;